if ( typeof ShippingNotice !== 'function' ) {

  /* ===== Stile della barra spedizione gratuita (Favella) ===== */
  if ( !document.getElementById('fav-ship-bar-style') ) {
    const style = document.createElement('style');
    style.id = 'fav-ship-bar-style';
    style.textContent = `
      .fav-ship-bar { height: 8px; border-radius: 999px; background: rgba(0,0,0,.08); overflow: hidden; margin: 0 0 10px; }
      .fav-ship-bar__fill { height: 100%; border-radius: 999px; background: #e8901a; transition: width .6s ease; }
      .fav-ship-bar.is-complete .fav-ship-bar__fill { background: #2e7d4f; }
      .fav-ship-text { display: block; text-align: center; }
    `;
    document.head.appendChild(style);
  }

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const thresholdConverted = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const freeShippingRemaining = cartTotal - thresholdConverted;
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      /* ===== Percentuale della barra ===== */
      const pct = thresholdConverted > 0 ? Math.min(100, (cartTotal / thresholdConverted) * 100) : 0;
      const startPct = typeof window.favShipLastPct === 'number' ? window.favShipLastPct : 0;
      window.favShipLastPct = pct;

      const barHtml = `
        <div class="fav-ship-bar ${shippingSuccess ? 'is-complete' : ''}" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(pct)}">
          <div class="fav-ship-bar__fill" style="width: ${startPct}%;"></div>
        </div>`;

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          ${barHtml}
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = `${barHtml}<span class="fav-ship-text">${shippingMessage}</span>`;
      }

      /* ===== Animazione dalla posizione precedente a quella nuova ===== */
      const fill = this.querySelector('.fav-ship-bar__fill');
      if ( fill ) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => { fill.style.width = pct + '%'; });
        });
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}